import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = { class: "overflow-hidden" }

import { computed } from "vue";
import { ArtifactLevelInputProps } from "@/types";
import { permissionStore, timStore, traceMatrixApiStore } from "@/hooks";
import { Typography, Chip, AttributeChip } from "@/components/common/display";


/**
 * Renders an input for changing the allowed artifact type directions.
 */
const __default__ = {
  name: "TypeDirectionInput",
};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: {
    artifactType: {}
  },
  setup(__props: any) {

const props = __props;

const allowedTypes = computed(() =>
  timStore.traceMatrices
    .filter(({ sourceType }) => sourceType === props.artifactType.name)
    .map(({ targetType }) => targetType)
);

/**
 * Converts an artifact type to a title case name.
 * @param type - The type to convert.
 * @return The type display name.
 */
function getTypeLabel(type: string) {
  return timStore.getTypeName(type);
}

/**
 * Removes an artifact type direction.
 * @param removedType - The type name to remove.
 */
function handleDelete(removedType: string) {
  traceMatrixApiStore.handleDeleteTypes(props.artifactType.name, removedType);
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Typography), {
      variant: "caption",
      color: "primary",
      value: "Parent Types"
    }),
    _createElementVNode("div", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(allowedTypes.value, (name) => {
        return (_openBlock(), _createBlock(_unref(AttributeChip), {
          key: name,
          value: getTypeLabel(name),
          "artifact-type": "",
          removable: _unref(permissionStore).isAllowed('project.edit_data'),
          "data-cy": "chip-type-direction",
          onRemove: ($event: any) => (handleDelete(name))
        }, null, 8, ["value", "removable", "onRemove"]))
      }), 128)),
      (allowedTypes.value.length === 0)
        ? (_openBlock(), _createBlock(_unref(Chip), {
            key: 0,
            outlined: "",
            label: "Any Type"
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})